//TODO: Una vez pasada la beta retirar
import { lazy } from 'react';
import DashboardLayout from 'layouts/DashboardLayout';
import { canUseCatalog } from 'utils/pos';

const Error404 = lazy(() => import('views/Errors/Error404'));

function PosBetaGuard({ children }) {
  if (!canUseCatalog()) {
    return <Error404 />;
  }
  return <DashboardLayout>{children}</DashboardLayout>;
}

export default PosBetaGuard;
